module.exports = __webpack_public_path__ + "img/male-profile.a0368181.png";